import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"add\"><g data-name=\"Group 6316\"><path data-name=\"Path 9753\" d=\"M8.031 0A8.031 8.031 0 0 0 0 7.969 8.085 8.085 0 0 0 8.031 16a8 8 0 0 0 0-16zm4.219 8.906H8.969v3.344a.938.938 0 0 1-1.875 0V8.906H3.75a.938.938 0 0 1 0-1.875h3.344V3.75a.938.938 0 0 1 1.875 0v3.281h3.281a.938.938 0 0 1 0 1.875z\" fill=\"#031425\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol